// extracted by mini-css-extract-plugin
export default {"hsAreaChart":"EmployerArea_hsAreaChart__Xc6DD"};